import { lazy } from 'react';
import { IRoute } from 'models/route';
import Loadable from 'components/Loadable';

const Login = Loadable(
	lazy(() => import('modules/Authentication/pages/Login')),
	true,
);
const ResetPassword = Loadable(
	lazy(() => import('modules/Authentication/pages/ResetPassword')),
	true,
);
const ResetPasswordRequest = Loadable(
	lazy(() => import('modules/Authentication/pages/ResetPasswordRequest')),
	true,
);

const AUTH_ROUTES: IRoute[] = [
	{
		path: 'login',
		element: Login,
		name: 'Login',
		roles: [],
		private: false,
	},
	{
		path: 'reset-password/:adminId/:resetToken',
		element: ResetPassword,
		name: 'ResetPassword',
		roles: [],
		private: false,
	},
	{
		path: 'reset-password-request',
		element: ResetPasswordRequest,
		name: 'ResetPasswordRequest',
		roles: [],
		private: false,
	},
];

export default AUTH_ROUTES;
